import type { NextPage } from 'next';
import { ZespolDesktop } from 'views';
import { SEO } from 'components';
import { PageProps, TeamMember } from 'models';
import { API } from 'API';

const Home: NextPage<PageProps<TeamMember[]>> = ({ data }) => {
  return (
    <>
      <SEO
        description="Strona zespołu polskiego radia"
        title="Zespół - Jedynka - polskieradio.pl"
        image="https://static.prsa.pl/images/aeb399b3-8157-4aa3-8447-6b8cb96c5d13.jpg"
      />
      <ZespolDesktop data={data} />
    </>
  );
};

export default Home;

export async function getStaticProps() {
  const res = await API.getTeam();
  return {
    props: {
      data: res?.data?.data,
    },
    revalidate: 600,
  };
}
